export default __webpack_public_path__ + "media/compass-background.b31b3bb4fd3de340d52c1f15ff2faf06.webp";